import { render, staticRenderFns } from "./RouteDepartures.vue?vue&type=template&id=c7fb38b8&scoped=true"
import script from "./RouteDepartures.vue?vue&type=script&lang=js"
export * from "./RouteDepartures.vue?vue&type=script&lang=js"
import style0 from "./RouteDepartures.vue?vue&type=style&index=0&id=c7fb38b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fb38b8",
  null
  
)

export default component.exports